import { render, staticRenderFns } from "./import_user.vue?vue&type=template&id=27b6a3cd&scoped=true&"
import script from "./import_user.vue?vue&type=script&lang=js&"
export * from "./import_user.vue?vue&type=script&lang=js&"
import style0 from "./import_user.vue?vue&type=style&index=0&id=27b6a3cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b6a3cd",
  null
  
)

export default component.exports